import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetBlogListFailed, EGetBlogListActionType } from './types';

export const getBlogListFailed: () => TGetBlogListFailed = actionGenerator<EGetBlogListActionType.Failed>(
  EGetBlogListActionType.Failed,
);
